import WallCalendar from "./components/Calendar/WallCalendar";

function App() {
  return <WallCalendar />;
}

export default App;